<template>
  <tr class="participant-row">
    <td class="participant-col">
      <lazy-image
        :src="user.thumbnailUrl"
        :fallback="require('@/assets/placeholder96x96.png')"
        :alt="user.firstName + ' ' + user.lastName"
        wrapperClass="participant__avatar"
      />
    </td>
    <td class="participant-col wide">
      <h4 @click="$emit('to-user', user.id)" class="participant__name">
        {{ user.firstName }} {{ user.lastName }}
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span
      ><span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="participant-col wide">
      <div style="display: flex; align-items: center;">
        Select new advisor:
        <dialog-select
          name="consultantId"
          :items="$attrs.selectAdvisors"
          item-text="fullName"
          item-value="id"
          :placeholder="
            $attrs.currentAdvisor
              ? $attrs.currentAdvisor.firstName +
                ' ' +
                $attrs.currentAdvisor.lastName
              : ''
          "
          @input="$emit('onInput', user.id, $event)"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DialogSelect from '@/components/forms/DialogSelect.vue'
import LazyImage from '../lazy/LazyImage.vue'

export default {
  name: 'PracticeUserPatientWithSelectTableRow',
  components: {
    DialogSelect,
    LazyImage,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {},
}
</script>

<style lang="scss">
table {
  min-width: 0 !important;
  width: 100% !important;
}
.participant {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 54px;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;
    &.wide {
      width: 45%;
    }
    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .dialog-select {
      width: 70%;
    }
    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
